import { AdoptionStep } from 'shared/libs/feature-adoption';
import { adoptionAnalytics } from 'shared/libs/feature-adoption/analytics';
import {
  HANDOFF_ADOPTION,
  HIGH_VALUE_USER_TAG_ADOPTION,
  NEW_USER_TAG_ADOPTION,
  PRINTED_ADOPTION,
} from '../domain';
import { useOrderDetailLang } from './useOrderDetailLang';

import type { MutableRefObject } from 'react';
import type { PartnerId, StoreId } from 'shared/domain';
import type { DriverInstance } from 'shared/libs/feature-adoption';

export function useOrderDetailAdoption(params: Params) {
  const { partnerId, storeId, tooltip } = params;
  const { text, disclaimer } = useOrderDetailLang();

  const _printedStep: AdoptionStep = {
    element: `#${PRINTED_ADOPTION}`,
    popover: {
      title: text.suggestion,
      description: disclaimer.scalePrinted,
      side: 'bottom',
      align: 'end',
      onNextClick: () => {
        adoptionAnalytics.log({ partnerId, storeId, feature: 'printer' });
        tooltip.current?.moveNext();
      },
    },
  };

  const _handoffStep: AdoptionStep = {
    element: `#${HANDOFF_ADOPTION}`,
    popover: {
      title: text.new,
      description: disclaimer.handoff,
      onPopoverRender: (_, opts) => {
        if (opts.config.steps?.length! > 1) {
          tooltip.current?.getActiveElement()?.scrollIntoView(true);
        }
      },
      onNextClick: () => {
        adoptionAnalytics.log({ partnerId, storeId, feature: 'handoff' });
        tooltip.current?.moveNext();
      },
    },
    onHighlighted: (activeElement, _, opts) => {
      if (opts.config.steps?.length === 1) {
        activeElement?.scrollIntoView(true);
        tooltip.current?.refresh();
      }
    },
  };
  const _newUserTagStep: AdoptionStep = {
    element: `#${NEW_USER_TAG_ADOPTION}`,
    popover: {
      title: text.userTag,
      description: disclaimer.newUser,
      onNextClick: () => {
        adoptionAnalytics.log({ partnerId, storeId, feature: 'user_tag' });
        tooltip.current?.moveNext();
      },
    },
  };
  const _highValueUserTagStep: AdoptionStep = {
    element: `#${HIGH_VALUE_USER_TAG_ADOPTION}`,
    popover: {
      title: text.userTag,
      description: disclaimer.highValueUser,
      onNextClick: () => {
        adoptionAnalytics.log({ partnerId, storeId, feature: 'user_tag' });
        tooltip.current?.moveNext();
      },
    },
  };
  return {
    step: {
      printed: _printedStep,
      handoff: _handoffStep,
      newUserTag: _newUserTagStep,
      highValueUserTag: _highValueUserTagStep,
    },
  };
}

type Params = {
  partnerId: PartnerId;
  storeId: StoreId;
  tooltip: MutableRefObject<DriverInstance | null>;
};
